@if (displayPage() && pageDetailsFetched()) {
  <div class="main_div" [class.blur-content]="util.isDialogOpen$()">
    @if (this.util.getStoredUserDetails()?.roleName) {
      <div dynamicScript="/assets/left-side-menu/left-side-menu-1.0.0.js">
        <left-side-menu [pageAccess]="pageAccess()" [institutionDetails]="localStorage.getItem('institutionDetails')" (navigate)="onNavigate($event)" [currentUrl]="router.url" />
      </div>
    }
    <div class="main_pg">
      <app-header></app-header>
      <div class="main_cnt"><router-outlet></router-outlet></div>
    </div>
  </div>
}

<!-- Institution changed in another tab popup -->
@if (showInstitutionChangePopup()) {
  <div class="institution_change_overlay">
    <div class="institution_change_popup">
      <div class="institution_change_title">Institution Changed</div>
      <div class="institution_change_body">
        The institution has been changed to <strong class="institution_highlight">{{changedInstitutionName()}}</strong> in another tab. You will be redirected to the updated institution.
      </div>
      <div class="institution_change_btn">
        <button class="institution_change_ok_btn" (click)="handleInstitutionChangeRedirect()">OK</button>
      </div>
    </div>
  </div>
}
